var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTelephone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 510.003 510.003",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.787 239.517L34.394 273.91 0 308.304v201.213h255.002l10-195-10-195.001H255l-97.998-9.848z",
    fill: "#27e7f0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M255.002 119.516v390.001H510V308.304l-34.392-34.394-34.395-34.393L360 119.516zM86.94 30.944c-12.17 5.239-23.153 11.053-32.892 17.399-11.157 7.271-20.68 15.244-28.482 23.858-8.203 9.058-14.451 18.731-18.718 28.952C2.393 111.828.1 123.1.001 134.891v22.312L0 179.516l75 10 75-10v-15c0-13.214 17.378-27.402 44.98-36.238 16.768-5.368 37.309-8.762 60.02-8.762h.002l10-59.513-10-59.513c-29.729.102-58.605 2.525-85.56 7.083-30.47 5.152-58.486 13.031-82.502 23.371z",
    fill: "#3ac0f1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M360 164.516v15l75 10 75-10v-44.44c.179-23.511-8.14-44.799-24.46-63.234-13.471-15.217-32.394-28.49-56.489-39.466-23.479-10.693-51.366-18.904-81.996-24.315C320.334 3.34 291.527.751 261.739.503a631.277 631.277 0 00-3.368-.017c-1.124-.002-2.246 0-3.368.004v119.026c22.711.001 43.252 3.394 60.019 8.762C342.623 137.115 360 151.302 360 164.516z",
    fill: "#3a97f1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M360 239.517h150V179.516H360v30z",
    fill: "#3a77f1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M150 239.517H0v-60.001h150z",
    fill: "#3a97f1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M350 344.517l8.925 15H390v-30H358.925z",
    fill: "#ccd2db"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M255 239.517c-28.948 0-55.198 11.775-74.211 30.788S150 315.568 150 344.517c0 28.948 11.776 55.198 30.789 74.211s45.263 30.789 74.211 30.789h.002l10-105-10-105h-.001z",
    fill: "#f3f5f9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M360 344.517c0-28.949-11.775-55.199-30.787-74.212-19.013-19.013-45.263-30.788-74.211-30.788v210c28.948-.001 55.198-11.776 74.211-30.789C348.225 399.714 360 373.465 360 344.517z",
    fill: "#e1e6f0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M255 299.517c-12.406 0-23.656 5.046-31.805 13.194C215.047 320.86 210 332.11 210 344.517c0 12.406 5.047 23.656 13.195 31.805 8.148 8.148 19.398 13.195 31.805 13.195h.002l10-45-10-45h-.001z",
    fill: "#e1e6f0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M300 344.517c0-12.407-5.046-23.657-13.194-31.805-8.147-8.148-19.397-13.195-31.804-13.195v90c12.406-.001 23.656-5.048 31.804-13.196S300 356.923 300 344.517z",
    fill: "#ccd2db"
  })));
}

export default SvgTelephone;